import { render, staticRenderFns } from "./Station.vue?vue&type=template&id=22f2f4d8&scoped=true"
import script from "./Station.vue?vue&type=script&lang=js"
export * from "./Station.vue?vue&type=script&lang=js"
import style0 from "./Station.vue?vue&type=style&index=0&id=22f2f4d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f2f4d8",
  null
  
)

export default component.exports